var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndependentWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.69 59.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3 0h-9.53C14.7 0 0 14.7 0 32.77v24.04a2.39 2.39 0 002.39 2.39c1.34 0 2.43-1.09 2.43-2.43l-.03-9.43c0-11.25 9.15-20.4 20.4-20.4a2.39 2.39 0 100-4.78c-8.15 0-15.66 3.87-20.4 10.44.1-15.34 12.61-27.8 27.98-27.8h7.13v21.64c0 15.43-12.55 27.98-27.98 27.98h-1.9a2.39 2.39 0 100 4.78h1.9c18.07 0 32.77-14.7 32.77-32.77V2.39A2.39 2.39 0 0042.3 0z",
    fill: "#fff"
  })));
}
export default SvgIndependentWebsite;